// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  customer/src/firebase/config.js  —  Quickry
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey:            "AIzaSyDRC7d36Jdz-0vMT2YthiZk9EyvHhnhFEw",
  authDomain:        "quickry-f3edc.firebaseapp.com",
  projectId:         "quickry-f3edc",
  storageBucket:     "quickry-f3edc.firebasestorage.app",
  messagingSenderId: "1018983581152",
  appId:             "1:1018983581152:web:3fb8cacb722117aca39785",
  measurementId:     "G-K1MFCZ56CK",
};

// Initialize Firebase
export const app      = initializeApp(firebaseConfig);
export const auth     = getAuth(app);
export const provider = new GoogleAuthProvider();

// Messaging — only in browser (not in service worker)
export const messaging = typeof window !== "undefined"
  ? getMessaging(app)
  : null;

export default app;